import { queryOptions } from '@tanstack/react-query';
import { AnalysisService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';
import { i18n } from '@/shared/i18n';
import type { IqDataSourceConnection } from '../model/types';
import { IQ_DATA_SOURCE_QUERY_KEYS } from './query-keys';

/**
 * Sources the workspace may see, each with its activation state. The backend filters by each
 * source's `iq_*` flag, so a flag-off source is simply absent — the frontend never checks
 * the flags itself, matching how the connectors surface treats platforms.
 */
export const iqDataSourcesQueryOptions = () =>
  queryOptions({
    queryKey: IQ_DATA_SOURCE_QUERY_KEYS.list(),
    queryFn: async ({ signal }): Promise<IqDataSourceConnection[]> => {
      // `throwOnError` because the inference client does not set it globally: without it a
      // 502 or a dropped connection resolves as an empty list, which every consumer here
      // reads as "this workspace has activated nothing" and caches for the query's lifetime.
      const response = await AnalysisService.listDataSources({
        client: inferenceHttp,
        signal,
        throwOnError: true,
      });
      return response.data.data;
    },
    // The global QueryCache.onError only toasts for queries carrying this.
    meta: { errorMessage: i18n.t('knowledge:dataSource.listFailed') },
  });
